import React, { useRef, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { useSelector } from 'react-redux'
import ReCAPTCHA from 'react-google-recaptcha'
import { createBrowserHistory } from 'history'
import ErrorDialog from 'src/components/common/ErrorDialog'
import {
  getToken,
  registerUser,
  validateOtp,
} from 'src/services/individualService'
import LoadingModal from 'src/components/common/LoadingModal'
import {
  ERROR_MESSAE,
  PASSWORD_SHARED_TO_EAMIL,
  USER_REGISTERED_SUCESSFULLY,
} from 'src/utils/constants/Registration'

const Otp = () => {
  let history = createBrowserHistory({ forceRefresh: true })
  const classes = useStyles()
  const reRef = useRef()

  const [loading, setLoading] = useState(false)
  const [modalOpen, setModalClose] = useState(false)
  const [message, setMessage] = useState('')
  const registerUserDetails = useSelector((state) => state?.registeruserInfo)
  const merged = useSelector((state) => state?.merged)
  const [showMessage, setShowMessage] = useState(false)

  const numberOfDigits = 6
  const [otp, setOtp] = useState(new Array(6)?.fill(''))
  const otpBoxReference = useRef([])

  const [emailOtp, setEmailOtp] = useState(new Array(6)?.fill(''))
  const emailOtpBoxReference = useRef([])

  const handleChangeOtp = (value, index, otpArray, setArray, boxReference) => {
    let newArr = [...otpArray]
    newArr[index] = value
    setArray(newArr)

    if (value && index < numberOfDigits - 1) {
      boxReference?.current[index + 1]?.focus()
    }
  }

  const handleBackspaceAndEnter = (e, index, boxReference) => {
    if (e?.key === 'Backspace' && !e?.target?.value && index > 0) {
      boxReference.current[index - 1].focus()
    }
    if (e?.key === 'Enter' && e?.target?.value && index < numberOfDigits - 1) {
      boxReference.current[index + 1]?.focus()
    }
  }

  const resendOTP = async (e) => {
    e?.stopPropagation()
    e?.preventDefault()
    setLoading(true)
    setOtp(new Array(6)?.fill(''))
    const res = await fetchToken()
    const token = await reRef.current.executeAsync()
    reRef.current.reset()
    const resp = await registerUser(
      registerUserDetails?.registeruserInfo?.firstName,
      registerUserDetails?.registeruserInfo?.emailId,
      registerUserDetails?.registeruserInfo?.mobileNumber,
      registerUserDetails?.registeruserInfo?.mobileNumber,
      token,
      res,
      registerUserDetails?.registeruserInfo?.lastName,
      merged
    )
    setMessage(resp?.res?.data?.message)
    setLoading(false)
    setShowMessage(true)
  }

  const handleSubmit = async (e) => {
    e?.stopPropagation()
    e?.preventDefault()
    setLoading(true)
    const res = await fetchToken()
    const token = await reRef.current.executeAsync()
    reRef.current.reset()

    const mobileOtpJoined = otp?.join('')
    const emailOtpJoined = emailOtp?.join('')

    const resp = await validateOtp(
      emailOtpJoined,
      mobileOtpJoined,
      registerUserDetails?.registeruserInfo?.mobileNumber,
      registerUserDetails?.registeruserInfo?.mobileNumber,
      registerUserDetails?.registeruserInfo?.firstName,
      registerUserDetails?.registeruserInfo?.emailId,
      registerUserDetails?.registeruserInfo?.lastName,
      res,
      token,
      merged
    )
    if (!resp?.res?.data?.success) {
      setMessage(resp?.res?.data?.message)
      setLoading(false)
      setShowMessage(true)
    } else {
      setLoading(false)
      setMessage(resp?.res?.data?.message)
      setShowMessage(true)
      setModalClose(true)
    }
  }

  const fetchToken = async () => {
    const response = await getToken()
    if (response?.res?.status !== 200) {
      setMessage(ERROR_MESSAE)
      setShowMessage(true)
    }
    return response?.res?.data?.access_token
  }

  return (
    <>
      <LoadingModal loading={loading} />

      {modalOpen ? (
        <ErrorDialog
          message={
            registerUserDetails?.registeruserInfo?.emailId
              ? PASSWORD_SHARED_TO_EAMIL
              : USER_REGISTERED_SUCESSFULLY
          }
          routeValue={'home'}
        />
      ) : null}

      <form id='otpForm' onSubmit={handleSubmit}>
        <div className={'flex'}>
          <p className={classes.enterOtpText}>Enter OTP</p>
        </div>

        <p className={classes.otpSentText}>
          OTP has been sent to +91 XXXXX XXXXX
        </p>

        <div className={classes.otpFieldsContainer}>
          {otp?.map((digit, index) => (
            <input
              key={`otp_${index}`}
              value={digit}
              placeholder='*'
              maxLength={1}
              onChange={(e) =>
                handleChangeOtp(
                  e?.target?.value,
                  index,
                  otp,
                  setOtp,
                  otpBoxReference
                )
              }
              onKeyUp={(e) =>
                handleBackspaceAndEnter(e, index, otpBoxReference)
              }
              ref={(reference) => (otpBoxReference.current[index] = reference)}
              className={classes.otpField}
            />
          ))}
        </div>

        {registerUserDetails?.registeruserInfo?.emailId ? (
          <>
            <p className={classes.otpSentText}>OTP has been sent to Email</p>

            <div className={classes.otpFieldsContainer}>
              {emailOtp?.map((digit, index) => (
                <input
                  key={`emailOtp_${index}`}
                  value={digit}
                  placeholder='*'
                  maxLength={1}
                  onChange={(e) =>
                    handleChangeOtp(
                      e?.target?.value,
                      index,
                      emailOtp,
                      setEmailOtp,
                      emailOtpBoxReference
                    )
                  }
                  onKeyUp={(e) =>
                    handleBackspaceAndEnter(e, index, emailOtpBoxReference)
                  }
                  ref={(reference) =>
                    (emailOtpBoxReference.current[index] = reference)
                  }
                  className={classes.otpField}
                />
              ))}
            </div>
          </>
        ) : null}

        <div className={classes.resendContainer}>
          <button onClick={resendOTP} className={classes.resendButton}>
            Resend
          </button>
        </div>

        {showMessage ? (
          <div className={classes.messageContainer}>{message}</div>
        ) : null}

        {registerUserDetails?.registeruserInfo?.emailId ? (
          <div className={classes.passwordSharedContainer}>
            <p className={classes.passwordSharedText}>
              <input type='checkbox' id='passwordCheckbox' required />
              Password will be shared to your registered email ID.
            </p>
          </div>
        ) : null}

        <div className={classes.reCaptchaContainer}>
          <ReCAPTCHA
            sitekey='6LfjGmcdAAAAAJYlclS6Cm8v48CFPj0oPRLx1tJh'
            ref={reRef}
            size='invisible'
          />
        </div>

        <div className={classes.submitContainer}>
          <button className={classes.submitButton}>Submit</button>
        </div>

        <div className={classes.cancelContainer}>
          <button
            className={classes.cancelButton}
            onClick={() => {
              history.push('/individual/dashboard/register')
            }}
          >
            Cancel
          </button>
        </div>

        <div className={classes.footerContainer}>
          <p className={classes.footerText}>
            &copy; 2022 Copyrights reserved by Trovity.
          </p>
        </div>
      </form>
    </>
  )
}

export default Otp

const useStyles = makeStyles({
  enterOtpText: {
    padding: '7px',
    fontSize: '24px',
    margin: '10% auto auto auto',
    textAlign: 'center',
    color: 'rgba(17, 47, 60, 1)',
  },
  otpSentText: {
    padding: '7px',
    fontSize: '12px',
    margin: '5% auto auto auto',
    textAlign: 'center',
    color: 'rgba(17, 47, 60, 0.6)',
  },
  otpFieldsContainer: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  otpField: {
    // border w-20 h-auto text-white p-3 rounded-md block bg-black focus:border-2 focus:outline-none appearance-none
    width: '30px !important',
    height: 'auto',
    fontSize: '25px',
    textAlign: 'center',
    borderRadius: '4px',
    border: '1px solid rgba(0, 0, 0, 0.3)',
    backgroundColor: 'rgba(232, 232, 232, 1)',
    '&.placeholder': {
      textAlign: 'center',
    },
  },
  resendContainer: {
    padding: '7px',
    fontSize: '14px',
    margin: '1% 0% auto auto',
    textAlign: 'center',
    color: 'rgba(2, 169, 244, 1)',
  },
  resendButton: {
    background: 'white',
    border: 'none',
    color: '#02A9F4',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  messageContainer: {
    margin: '15px auto 5px auto',
    color: 'red',
    width: '57%',
    fontSize: '15px',
    textAlign: 'center',
  },
  passwordSharedContainer: {
    margin: '1% auto auto auto',
    textAlign: 'center',
  },
  passwordSharedText: {
    fontSize: '12px',
    color: 'rgba(17, 47, 60, 0.6)',
  },
  reCaptchaContainer: {
    marginLeft: '50px',
  },
  submitContainer: {
    margin: '25px auto 5px auto',
    textAlign: 'center',
  },
  submitButton: {
    textTransform: 'unset',
    backgroundColor: '#B92250',
    color: 'white',
    fontSize: '16px',
    padding: '10px 20px 10px 20px!important',
    borderRadius: '50px',
    fontWeight: 'bold',
    border: 'none',
    cursor: 'pointer',
  },
  cancelContainer: {
    padding: '7px',
    fontSize: '12px',
    margin: '1% 0% auto auto',
    textAlign: 'center',
    color: 'rgba(17, 47, 60, 0.4)',
  },
  cancelButton: {
    backgroundColor: 'white',
    border: 'none',
    cursor: 'pointer',
  },
  footerContainer: {
    margin: '15% auto auto auto',
    textAlign: 'center',
  },
  footerText: {
    fontSize: '9px',
    color: 'rgba(17, 47, 60, 0.6)',
  },
})
